import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import Home from './pages/Home';
import Products from './pages/Products';
import Cart from './pages/Cart';
import Review from './pages/Review';
import Navbar from './components/Navbar';
import Checkout from './pages/Checkout';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  return (
    <Router>
      <Navbar />

      <Routes>
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/review" element={<Review />} />

      </Routes>

      {/* ✅ ToastContainer ONLY ONCE */}
      <ToastContainer position="top-right" autoClose={2000} />
    </Router>
  );
};

export default App;